import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import { GoldConversionStatusEnum } from '~utils/enums';

export default function* watchGetGoldConversionListing(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldGetGoldConversionListingAttempt', handleGetGoldConversionListing, api);
}

function* handleGetGoldConversionListing(api: GoldGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const { index, filters: { customerName, idNo, branchName, status, dateTo, dateFrom } } = reduxState.gold.goldConversion;

    if (!index && index !== 0) {
        yield put(combinedActions.goldGetGoldConversionListingFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        return;
    }

    const response = yield* call([api, api.getGoldConversionListing], {
        authToken,
        index,
        customerName: customerName || undefined,
        idNo: idNo || undefined,
        branchName: branchName || undefined,
        status: status ? GoldConversionStatusEnum[status as keyof typeof GoldConversionStatusEnum] : undefined,
        dateTo: dateTo || undefined,
        dateFrom: dateFrom || undefined,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.goldGetGoldConversionListingFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.goldGetGoldConversionListingSuccess(response.data));
    }
}
